// @ts-ignore
const getGoalType = (goalType: string, transactionType: string) => {
  if (goalType === 'event') {
    return 'イベントトラッキング';
  } else if (goalType === 'page_visit') {
    return 'ページ訪問';
  } else if (goalType === 'transaction') {
    if (transactionType === 'amount') return 'トランザクション(総額)';
    else if (transactionType === 'quantity') return 'トランザクション(数量)';
  } else if (goalType === 'click') {
    return 'クリックトラッキング';
  } else {
    return '';
  }
};

export default getGoalType;
